<template>
  <div class="box">
    <div class="top">
      <div class="top-a"></div>
      <p class="top-b">报障科室分析</p>
    </div>
    <div class="middle">
      <div class="middle-a">
        <Space wrap>
          <RadioGroup
            v-model="button"
            type="button"
            border="false"
            button-style="solid"
            @on-change="jinr(button)"
          >
            <Radio label="今日"></Radio>
            <Radio label="本周"></Radio>
            <Radio label="本月"></Radio>
          </RadioGroup>
        </Space>
      </div>
      <div class="middle-b">
        <Space size="large" wrap>
          <DatePicker
            :options="options"
            type="daterange"
            placement="bottom-end"
            placeholder="选择时间"
            style="width: 250px"
            clearable="true"
            @on-change="handleDateChange"
          />
        </Space>
      </div>
      <div class="middle-c">
        <Button type="primary" class="middle-ca" @click="search">搜索</Button>
        <Button class="middle-cb" @click="toinfo"
          >详情<Icon type="ios-arrow-forward"
        /></Button>
      </div>
    </div>
    <div class="bottom">
      <Table
        :columns="columns"
        :row-class-name="rowClassName"
        :data="data"
        height="230"
      ></Table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      button: "本月",
      columns: [
        {
          title: "排名",
          width: "70",
          key: "ranking",
        },
        {
          title: "科室名称",
          key: "name",
          tooltip: "true",
        },
        {
          title: "工单数量",
          key: "total",
        },
        {
          title: "占比",
          key: "percentage",
        },
      ],
      data: [],
      options: {
        disabledDate: (date) => {
          if (this.endMonth) {
            let endDate = this.getDate(this.endMonth);
            return (date && date > endDate) || date > new Date();
          } else {
            return date && date > new Date();
          }
        },
      },
      startDate: "",
      endDate: "",
    };
  },
  created() {
    this.loadHomeData(this.benyue(), this.dangqian());
  },
  methods: {
    search() {
      this.loadHomeData(this.startDate, this.endDate);
    },
    toinfo() {
      $utils.url.push({
        name: "oneinfo_index",
      });
    },
    jinr(item) {
      switch (item) {
        case "今日":
          this.loadHomeData(this.zhengdain(), this.dangqian());
          break;
        case "本周":
          this.loadHomeData(this.benzhou(), this.dangqian());
          break;
        case "本月":
          this.loadHomeData(this.benyue(), this.dangqian());
          break;
      }
    },
    rowClassName(row, index) {
      if (index === 0) {
        return "demo-one demo";
      } else if (index === 1) {
        return "demo-two demo";
      } else if (index === 2) {
        return "demo-three demo";
      } else if (index === 3 || index === 4) {
        return "demo-four demo";
      }
      return "";
    },
    loadHomeData(a, b) {
      let q = {
        begin: a,
        end: b,
      };
      $utils.api.load("/admin/statistics/deskCountNew", q, "GET").then((res) => {
        if (res.data) {
          let info = res.data || {};
          this.data = info.slice(0, 5);
        }
      });
    },
    //本月第一天
    benyue() {
      var date = new Date();
      date.setDate(1);
      var dateStart =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date.getDate().toString().padStart(2, "0") +
        " " +
        "00:00:00";
      return dateStart;
    },
    //当前时间
    dangqian() {
      const now = new Date(); // 创建一个表示当前时间的 Date 对象
      const year = now.getFullYear(); // 获取当前年份
      const month = now.getMonth() + 1; // 获取当前月份（注意月份是从 0 开始的，所以需要加 1）
      const day = now.getDate(); // 获取当前日期
      const hours = now.getHours(); // 获取当前小时数（0-23）
      const minutes = now.getMinutes(); // 获取当前分钟数（0-59）
      const seconds = now.getSeconds(); // 获取当前秒数（0-59）
      const formattedDate = `${year}-${month
        .toString()
        .padStart(2, "0")}-${day.toString().padStart(2, "0")} ${hours
        .toString()
        .padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`; // 格式化为 "yyyy-MM-dd HH:mm:ss" 格式
      return formattedDate;
    },
    //今日整点时间
    zhengdain() {
      const now = new Date(); // 创建一个表示当前时间的 Date 对象
      now.setHours(0, 0, 0, 0); // 将时间部分设置为 00:00:00
      const year = now.getFullYear(); // 获取年份
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0"); // 获取日期
      const formattedDate = `${year}-${month}-${day} 00:00:00`; // 格式化为 "yyyy-MM-dd HH:mm:ss" 格式
      return formattedDate;
    },
    //本周第一天
    benzhou() {
      const now = new Date();
      const firstDayOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
      const year = firstDayOfWeek.getFullYear(); // 获取年份
      const month = (firstDayOfWeek.getMonth() + 1).toString().padStart(2, "0");
      const day = firstDayOfWeek.getDate().toString().padStart(2, "0");
      const formattedDate = `${year}-${month}-${day} 00:00:00`;
      return formattedDate;
    },
    handleDateChange(date) {
      const startDate = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
      const endDate = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
      this.startDate = startDate;
      this.endDate = endDate;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 330px;
  padding: 10px;
  overflow: hidden;
}
.top {
  display: flex;
  height: 20px;
  margin-bottom: 10px;
  .top-a {
    width: 10px;
    height: 100%;
    background-color: #46a6ff;
  }
  .top-b {
    margin-left: 7px;
    font-weight: 600;
    color: black;
  }
}
.middle {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  .middle-a {
    margin-right: 8px;
  }
  .middle-b {
    margin-right: 8px;
  }
  .middle-c {
    .middle-ca {
      margin-right: 8px;
    }
  }
}
.bottom {
  height: 230px;
}
/deep/.ivu-table .demo td {
  height: 35px;
}
/deep/.ivu-table .demo-one td {
  font-weight: 600;
  color: red;
}
/deep/.ivu-table .demo-two td {
  font-weight: 600;
  color: #ffc621;
}
/deep/.ivu-table .demo-three td {
  font-weight: 600;
  color: blue;
}
/deep/.ivu-table .demo-four td {
  font-weight: 600;
}
.ivu-radio-group-button-solid
  .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled) {
  background: #46a6ff;
  color: #fff;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked {
  border-color: #46a6ff;
  box-shadow: -1px 0 0 0 #46a6ff;
  z-index: 1;
}
.ivu-radio-group-button .ivu-radio-wrapper:hover {
  position: relative;
  color: #46a6ff;
}
.ivu-radio-group-button-solid
  .ivu-radio-wrapper-checked:not(.ivu-radio-wrapper-disabled):hover {
  background: #46a6ff;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked:hover {
  border-color: #46a6ff;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus {
  box-shadow: none;
  transition: none;
}
.iwu-btn-primary:focus {
  box-shadow: none;
}
.ivu-btn:focus {
  box-shadow: none;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked:before {
  background: none;
  opacity: 0;
}
.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
  transition: none;
}
.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
  opacity: 0;
}
.ivu-radio-group-button .ivu-radio-wrapper:before,
.ivu-radio-group-button .ivu-radio-wrapper:after {
  background: none;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked:first-child {
  border-color: #46a6ff;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:first-child {
  box-shadow: none;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus:after {
  opacity: 0;
}
</style>
